
import { BaseReport } from '../components/BaseReport';
import { useScan, useScanComponents, useScanVulnerabilities, useLatestSuccessfulScan } from '@/hooks/useScans';

interface ProjectViewReportProps {
  onNavigate?: (route: string, params?: any) => void;
  projectId?: number;
}

export function ProjectViewReport({ onNavigate, projectId }: ProjectViewReportProps) {
  const { data: latestSuccessfulScan, loading: scansLoading } = useLatestSuccessfulScan(projectId);
  const scanId = latestSuccessfulScan?.id;

  const { data: scanData, refetch } = useScan(scanId);
  const { data: scanComponents } = useScanComponents(scanId);
  const { data: scanVulnerabilities } = useScanVulnerabilities(scanId);

  if (scansLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <div className="text-muted-foreground">Loading project scans...</div>
        </div>
      </div>
    );
  }

  if (!latestSuccessfulScan) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="text-lg font-medium mb-2">No Scan Data Available</div>
          <div className="text-muted-foreground">
            No successful scans found for this project. Please run a successful scan first.
          </div>
        </div>
      </div>
    );
  }

  return (
    <BaseReport
      onNavigate={onNavigate}
      onRefresh={refetch}
      reportType="scan"
      scanData={{
        details: scanData,
        components: scanComponents,
        vulnerabilities: scanVulnerabilities,
      }}
    />
  );
}